import { ExtraEventPropsType } from './windowType';

const isProduction = process.env.PROCESS_ENVIRONMENT === 'production';
const isStaging = process.env.NEXT_PUBLIC_ENV === 'staging';

/**
 * A function that triggers a push to
 * window.dataLayer for production environment
 * @param {string} action
 * @param {string} category
 * @param {string} label
 * @param {ExtraEventPropsType} extraEventProps
 */
const createGtagEvent = (action: string, category: string, label?: string, extraEventProps?: ExtraEventPropsType) => {
  if (isProduction || isStaging) {
    if (!window.dataLayer) window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: action, event_category: category, event_label: label, ...extraEventProps });
  }
};

export default createGtagEvent;
